import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHeart,
  faCartShopping,
  faShop,
  faMoneyBill,
  faHandsClapping,
  faStar,faStarHalf,faTimes,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
library.add(faHeart, faStar, faStarHalf, faCartShopping, faShop, faMoneyBill, faHandsClapping,faTimes, faBars,);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
